import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { getStorage } from "firebase/storage";



// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDo2K4MzR_IxOfol0EvwyAOV_RYru_Xj00",
  authDomain: "elysian-wellness.firebaseapp.com",
  projectId: "elysian-wellness",
  storageBucket: "elysian-wellness.firebasestorage.app",
  messagingSenderId: "178074041322",
  appId: "1:178074041322:web:44b186780cb6f5dee55093"
};



const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection };  // Correct export
















